// In the BP this should be empty. Enter your custom JS here

$('#openSidebarMenu').click(function (e) {
    if ($(this).is(':checked')) {
        $('body').addClass('locked');
    } else {
        $('body').removeClass('locked');
    }
})

$('.js-trigger-search-btn').on('click', function () {
    const searchField = $('.mob-search-field');

    if (!searchField.is(":visible")) {
        window.setTimeout(() => searchField.find('input')[0].focus(), 500);
    }
    searchField.slideToggle();
    return false;
});

$('#interestsForm .btn-check').click(function (e) {
    $('#interestsForm .btn-primary').text('Confirm');
});

// region Slick Sliders
$(document).ready(function () {
    let $navCarousel = $('.js-cat-nav-carousel');
    if ($navCarousel.length) {

        $navCarousel.slick({
            infinite: false,
            slidesToShow: 1,
            variableWidth: true,
        });
    }
});
// endregion

$(document).on('shown.bs.modal', function (e) {
    const target = e.relatedTarget;

    if (target) {
        const elementId = target.getAttribute('data-bs-target');
        const modal = document.getElementById(elementId.replace('#', ''));
        const redemption = modal.getAttribute('data-redemption');
        const offerUid = modal.getAttribute('data-uid');

        const modalContent = $(modal).find('.modal-body-code-content');

        if (redemption === 'code' && elementId.includes('-redeem-modal')) {
            axios
                .post($('#offer-refer-url').attr('data-url'), {
                    uid: offerUid
                })
                .then(function (response) {
                    if (response.data) {
                        $(modalContent).html(response.data.content);
                    }
                });
        }
    }

});

$(document).on('click', '#showMore', function (e) {
    const area = $(this).attr('data-area');
    const offerContainer = $('.offerRows');
    const showMoreButton = $('#showMore');
    const showMoreUrl = $('#offer-show-more-url');
    const sortBy = $(this).attr('data-sort_by');

    //console.log('Remove show more button');
    $(showMoreButton).remove();

    axios
        .post(showMoreUrl.attr('data-url'), {
            area: area,
            sortBy: sortBy,
        })
        .then(function (response) {
            if (response.data) {
                $(offerContainer).append(response.data.content);

                if (response.data.nextPage) {
                    //console.log('Update show more link');
                    const linkWithNoPageParam = $(showMoreUrl).attr('data-url').slice(0, ($(showMoreUrl).attr('data-url').indexOf('?page=') - $(showMoreUrl).attr('data-url').length));
                    $(showMoreUrl).attr('data-url', linkWithNoPageParam + '?page=' + response.data.nextPage);

                    checkScroll();
                }
            }
        });
});

$(document).on('click', '.redeemLink', function (e) {
    const offerUid = $(this).attr('data-uid');
    const redeemLinkUrl = $('#offer-redeem-link-url');

    // Open a blank tab immediately — iOS allows this
    const newTab = window.open('', '_blank');

    axios.post(redeemLinkUrl.attr('data-url'), {
        uid: offerUid
    })
        .then(function (response) {
            if (response.data && response.data.success === true) {
                // Navigate the pre-opened tab
                newTab.location.href = response.data.content;
            } else {
                newTab.close(); // Optional: close if error
            }
        })
        .catch(function () {
            newTab.close(); // Optional: close on failure
        });
});

$(document).on('click', '.js-copy-code', function () {
    let copyText = $(this);
    let codeInput = document.createElement("input");
    let value = copyText.data('code');

    codeInput.value = value;
    document.body.appendChild(codeInput);
    codeInput.select();
    codeInput.setSelectionRange(0, 99999);

    try {
        navigator.clipboard.writeText(value);
    } catch (err) {
        document.execCommand("copy");
    }

    document.body.removeChild(codeInput);

    alert("Copied the text: " + value);
});

$(document).on('click', '.offer-card', function (e) {
    if ($(e.target).hasClass('fa-heart')) {
        return;
    }

    const partnerUrl = $(this).attr('data-partner-url');
    if (partnerUrl) {
        window.location.href = partnerUrl;
    }
})

$('#submitRegistration').on('click', function (e) {

    const validateUrl = $('#validate-url');
    const registerUrl = $('#register-url');

    const form = $('#registrationForm');

    if (!form[0].checkValidity()) {
        form[0].reportValidity();
    } else {
        // Submit to backend for validation test
        axios
            .post(validateUrl.attr('data-url'),
                form.serialize(),
            )
            .then(function (response) {
                // Form validates OK
                // Switch form URL to register URL
                form.attr('action', registerUrl.attr('data-url'));

                // Check marketing preferences selected
                const pref1 = $('input[id="preference[1]"]')[0].checked;

                if (!pref1) {
                    // Pop up modal if none are selected
                    $('#register-preferences-modal').modal('show');
                } else {
                    form.submit();
                }

            })
            .catch(function (error) {
                if (error.response) {
                    // Form does not validate
                    // Submit the form to the validate URL so that it reloads with errors
                    form.attr('action', validateUrl.attr('data-url'));
                    form.submit();
                }
            });
    }
});

$('.updatePreference').click(function (e) {
    console.log('Click', $(this)[0], e.target.id);

    const thisPreference = $('input[id="' + e.target.id + '"]')[0];

    if (thisPreference) {
        const value = thisPreference.checked;
        const targetPreference = $('input[id="preference[' + e.target.id + ']"]')[0];

        targetPreference.checked = value;
        console.log(value);
    }
});

$('#preferenceConfirm').click(function (e) {
    e.preventDefault();

    const form = $('#registrationForm');
    form.submit();
})

$(document).ready(function () {
    // Display any modals that have been set to data-display-modal=1
    $('.onloadModal[data-display-modal="1"]').each(function (e) {
        var thisModal = $(this);
        $(thisModal).modal('show');
    });

    // Auto scroll navigation to the selected element (for mobile)
    const activeIndexString = $('.js-cat-nav-carousel .area-link.active').closest('.slick-slide').attr('data-slick-index');
    const activeIndexNumber = Number(activeIndexString);

    $('.js-cat-nav-carousel').slick('slickGoTo', activeIndexNumber - 1);
});

$(document).ready(function () {
    resizeBanners();

    let currentScreen = null;
    let breakpoints = [750];
    $(window).resize(function () {
        if ((!currentScreen || currentScreen === 'desk') && $(window).width() < breakpoints[0]) {
            resizeBanners();
            currentScreen = 'mob';
        } else if ((!currentScreen || currentScreen === 'mob') && $(window).width() >= breakpoints[0]) {
            resizeBanners();
            currentScreen = 'desk';
        }
    });

    if ($('#showMore').length) {
        checkScroll();
    }
});

function resizeBanners() {
    // Look at all carousels and make the same height as the largest
    let largestHeight = 0;
    const bannerSliders = $('.js-carousel .banner-wrapper');
    $(bannerSliders).each(function (e) {
        $(this).css('min-height', '');
        if ($(this).height() > largestHeight) {
            largestHeight = $(this).height();
        }
    });
    $(bannerSliders).each(function (e) {
        $(this).css('min-height', largestHeight + 10 + 'px');
    });
}

function checkScroll() {
    const scrollElement = $('#showMore');

    if (scrollElement) {
        $(window).scroll(function () {
            var top_of_element = $(scrollElement).offset().top;
            var bottom_of_element = $(scrollElement).offset().top + $(scrollElement).outerHeight();
            var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
            var top_of_screen = $(window).scrollTop();

            if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
                $('#showMore').click();
            }
        });
    }
}

$('.js-carousel').on('afterChange', function (event, slick, currentSlide) {
    setTimeout(function () {
        $('.js-carousel .slick-slide.slick-current').attr('aria-hidden', false);
    }, 100);
});

const togglePasswords = document.querySelectorAll(".password-toggle-icon i");

for (let i = 0; i < togglePasswords.length; ++i) {
    const togglePassword = togglePasswords[i];
    togglePassword.addEventListener("click", function (e) {
        const fieldId = e.target.getAttribute('data-field_id');
        const passwordField = document.getElementById(fieldId);

        if (passwordField.type === "password") {
            passwordField.type = "text";
            togglePassword.classList.remove("fa-eye");
            togglePassword.classList.add("fa-eye-slash");
        } else {
            passwordField.type = "password";
            togglePassword.classList.remove("fa-eye-slash");
            togglePassword.classList.add("fa-eye");
        }
    });
}

// region on change subject  answer
$(document).on('change', '#subject', function (event) {
    event.preventDefault();

    let value = $(this).val();

    if (value === '') {
        $('#message-answer').val('');
    } else {
        $.ajax({
            method: 'get',
            url: $('.js-message-answer').attr('data-url'),
            data: {subject: $(this).val()},
            dataType: 'json',
            success: function (response) {
                $('#message-answer').text(response.content);
            }
        });
    }
});

// endregion
